import React from 'react';


export default class CarouselImage extends React.Component{
  constructor(props) {
    super(props);
    this.state = {image: "loading" };
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.handleImageErrored = this.handleImageErrored.bind(this);
  }


  handleImageLoaded() {

   }

   handleImageErrored() {
      this.setState({ image: 'error' });

   }



  render(){
   var fallback = "https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/venue_fallback.png";
   var whenNoImage = "https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/venue_fallback.png";


   try{
     var imageSrc = this.props.src ? this.props.src : whenNoImage;
   }catch(err){
     imageSrc = whenNoImage;
    }


    return (
       <div className="all-offer-images" style={this.props.style}>
         {/*{this.props.viewport ? <span/> :   <img  ref="bull"*/}
                                               {/*className="blurred-background"*/}
                                               {/*alt={this.props.name}*/}
                                               {/*src= {this.state.image == "error" ? fallback : imageSrc}*/}
                                               {/*onLoad={this.handleImageLoaded}*/}
                                               {/*onError={this.handleImageErrored}*/}
                                              {/*/>}*/}


        <img  ref="bullRing"
              className="offer-detail-image-style"
               alt={this.props.name}
              src= {this.state.image == "error" ? fallback : imageSrc}
              onLoad={this.handleImageLoaded}
              onError={this.handleImageErrored} />

       </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Offer-detail-page/ImageGallery/carouselImage.js